export const AvatarType = {
  User: "user",
  AI: "ai",
};
